export const UserTypes = {
  "ADD_LOCATION": "ADD_LOCATION",
  "SET_WIND_TOGGLE_TYPE": "SET_WIND_TOGGLE_TYPE",
  "SET_ALERT_MESSAGE": "SET_ALERT_MESSAGE",
  "SET_LOADING": "SET_LOADING",
  "RESET_MAP": "RESET_MAP",
  "SET_POLLUTANT_POPUP_TYPE": "SET_POLLUTANT_POPUP_TYPE",
  "SET_RELOAD_STATIC_DATA": "SET_RELOAD_STATIC_DATA",
};
